import { LocationAddress } from './LocationAddress';
import { ContactPerson } from './ContactPerson';
export class EquipmentLocation {
    constructor() {
        this.address = new LocationAddress();
        this.contactPerson = new ContactPerson();
    }
}
